<template>
  <div
    class="flex items-center gap-2 overflow-x-auto -mx-1 px-1 custom-scrollbar sm:flex-wrap sm:overflow-visible"
    role="tablist"
    :aria-label="ariaLabel"
  >
    <button
      v-for="pill in pills"
      :key="pill.key"
      type="button"
      role="tab"
      :aria-selected="activeKey === pill.key"
      class="inline-flex items-center gap-1.5 shrink-0 h-10 px-3 text-[11px] font-medium rounded-xl border transition-all duration-200"
      :class="pillClass(pill.key)"
      @click="$emit('update:activeKey', pill.key)"
    >
      <i
        v-if="pill.icon"
        class="mdi text-[14px] shrink-0 opacity-80"
        :class="pill.icon"
      ></i>
      <span>{{ pill.label }}</span>
      <span
        v-if="pill.count != null"
        class="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 text-[10px] font-semibold tabular-nums rounded-md"
        :class="countClass(pill.key)"
      >
        {{ pill.count }}
      </span>
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  pills: { type: Array, required: true },
  activeKey: { type: String, required: true },
  ariaLabel: { type: String, default: "Ticket filters" },
});

defineEmits(["update:activeKey"]);

function pillClass(key) {
  if (props.activeKey === key) {
    return "border-primary/25 bg-primary/8 text-primary shadow-sm shadow-primary/5 ring-1 ring-primary/10 dark:bg-primary/15 dark:border-primary/30";
  }
  return "border-slate-200/80 dark:border-slate-700/80 bg-white/70 dark:bg-slate-900/50 text-slate-600 dark:text-slate-300 hover:border-primary/20 hover:bg-primary/5 hover:text-primary dark:hover:bg-primary/10";
}

function countClass(key) {
  if (props.activeKey === key) {
    return "bg-primary/15 text-primary dark:bg-primary/20";
  }
  return "bg-slate-100/90 dark:bg-slate-800 text-slate-500 dark:text-slate-400";
}
</script>
